import PropTypes from 'prop-types'
import { idPropType } from './id-prop-type'

/**
 * Proptype that represents a mapping of an item (its id) to a source (its id)
 * @typedef {Object}        itemMappingPropType
 * @param   {idPropType}    itemId
 * @param   {idPropType}    sourceId
 */
export const itemMappingPropType = PropTypes.shape({
    itemId: idPropType.isRequired,
    sourceId: idPropType.isRequired
})
